export default __webpack_public_path__ + "static/media/email-svgrepo-com.46a2a41b.svg";